import {useEffect, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {IMenusAndSubmenus, IRoleDetailsAPIRes, Role} from '../_model'
import {
  GET_ROLE_DETAILS_URL,
  transformRoleDetailsArray,
} from '../../../../utils/contextProvider/UserStateProvider'
import axios from 'axios'

type Props = {
  selectedRole: Role | null
  onResetSelected: () => void
}

const ViewAssignedRoleDetails = ({selectedRole, onResetSelected}: Props) => {
  const [roleDetailMenus, setRoleDetailMenus] = useState<IMenusAndSubmenus[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const getUserRoleDetails = async (id: number) => {
    try {
      setIsLoading(true)
      const response = await axios.get<IRoleDetailsAPIRes[]>(`${GET_ROLE_DETAILS_URL}${id}`)
      const transformed = transformRoleDetailsArray(response.data)
      setRoleDetailMenus(transformed)
      setIsLoading(false)
    } catch (error) {
      console.log(error)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    onResetSelected()
    if (selectedRole) {
      getUserRoleDetails(selectedRole?.id_level!)
    }
  }, [selectedRole])

  return (
    <div className='modal fade' tabIndex={-2} id='kt_modal_2'>
      <div className='modal-dialog modal-dialog-centered modal-xl'>
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Assigned Permission</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={onResetSelected}
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            {isLoading ? (
              <div className='h-300px fs-3 fw-semibold text-center'>
                <div className='d-flex justify-content-center'>
                  <div className='spinner-border' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {roleDetailMenus.map((menu) => (
                  <div key={menu.id_menu}>
                    <label className='d-flex align-items-center mb-6'>
                      {menu.view_level === 'Y' && (
                        <i className='bi bi-check-square-fill text-primary fs-4'></i> // bootstrap icon
                      )}
                      <span className='fs-4 fw-bold ms-3'>{menu.menu_name}</span>
                    </label>

                    {menu.submenus?.map((sub) => (
                      <div key={sub.id_submenu} style={{paddingLeft: '20px'}}>
                        <label className='d-flex align-items-center mb-3'>
                          {sub.view_level === 'Y' && (
                            <i className='bi bi-check-square-fill text-primary fs-4'></i>
                          )}
                          <span className='fs-4 fw-bold ms-3'>{sub.submenu_name}</span>
                        </label>
                      </div>
                    ))}
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewAssignedRoleDetails
